import React, { useState } from 'react'
import others from '../../../../../../../../../public/assets/img/WomansCategory/others.png'
import aroww from '../../../../../../../../../public/assets/img/WomansCategory/aroww.png'
import { WOMEN_FIND_YOUR_STYLE } from 'src/Helpers/Json/WomanCategoryList'
import AosAnimation from 'src/utils/AosAnimation'

export default function FindYourStyleMobile({ setsubPage, Cards, selectedStyle }) {
  const [MobileviewSidebar, setMobileviewSidebar] = useState(false)
  const [styleName, setStyleName] = useState(selectedStyle?.name ? selectedStyle?.name : WOMEN_FIND_YOUR_STYLE[0].name)

  const hanleSelect = (style) => {
    setStyleName(style.name)
  }

  return (
    <React.Fragment>
      <div className="women-mobile-view-details-fashion-name-search-alignment">
        <div className="width-alignment">
          {/* MobileView Sidebar Alignment */}
          <div className="mobile-view-sidebar-alignment">
            <div className="mobile-search-sidebar-details-box-alignment">
              {MobileviewSidebar && (
                <div className="mobile-view-sidebar-box-alignment">
                  <div className="mobile-silder-side-main-details">
                    {WOMEN_FIND_YOUR_STYLE.map((style, index) => {
                      return (
                        // <div className="find-fashion-border-alignment find-fashion-border-active">
                        <div
                          className="find-fashion-border-alignment"
                          onClick={() => hanleSelect(style)}
                          key={`y${index + 1}`}
                        >
                          <div className="find-fashion-box-alignment" style={{ backgroundColor: style.color }}>
                            <div className="fashion-img-alignment">
                              <img src={style?.image} alt="bgImg" />
                              <div className="fashion-option-name-alignment">
                                <h5>{style?.name}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
              {/* <div
                className="mobile-view-left-arrow-alignment"
                onClick={() => setMobileviewSidebar(!MobileviewSidebar)}
              >
                <img src="/assets/icon/left-icon.svg" alt="back-page" />
              </div> */}
            </div>
            {/* MobileView Child-heading */}
            <div className="width-alignment">
              <div
                className="mobile-view-child-heading-alignment"
                style={MobileviewSidebar ? { gap: 55 } : { justifyContent: 'space-between' }}
              >
                <div className="mobile-view-child-name-alignment">
                  <h5>{styleName}</h5>
                  <span>(654 item)</span>
                </div>
                {/* <div className="mobile-search-icon-alignment">
                  <img src="/assets/icon/Search-grey-icon.svg" />
                </div> */}
              </div>
              <>
                <div className="women-mobile-findYourStyle_product_block_empty_state">
                   <img src={'/assets/img/emptystateimage/emptystateimage2.png'} alt="Emptystateimage2"/>
                   <p>{"Not Found :("}</p>
                </div>
                {/* <div>
                  <div className="women-mobile-findYourStyle_product_block women-find-style-details">
                    <div className="row findYourStyle_product_block_row ">
                      {Cards.map((Data, i) => {
                        return Data.parent_fill ? (
                          <React.Fragment key={`d${i + 1}`}>
                            <AosAnimation animationType="fade-up" duration={2500} delay={250}>
                              <div className="card_col">
                                <div className="find-your-style-cardcover">
                                  <div className="card_top">
                                    <img src={Data.child[0].img.src} alt="card_top_img" />
                                  </div>
                                  <div className="card_bottom">
                                    <div className="card_bottom_cover">
                                      <h4>Plain And Check Shirts</h4>

                                      <p className="hike">
                                        <span className="inter">
                                          <img src={others.src} alt="hike" /> Interest
                                        </span>
                                        <span className="incris">
                                          <img src={aroww.src} alt="incris" /> 200%
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="find-your-style-cardcover">
                                  <div className="card_top">
                                    <img src={Data.child[1].img.src} alt="card_top_img" />
                                  </div>
                                  <div className="card_bottom">
                                    <div className="card_bottom_cover">
                                      <h4>Plain And Check Shirts</h4>

                                      <p className="hike">
                                        <span className="inter">
                                          <img src={others.src} alt="hike" /> Interest
                                        </span>
                                        <span className="incris">
                                          <img src={aroww.src} alt="incris" /> 200%
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </AosAnimation>
                          </React.Fragment>
                        ) : (
                          <React.Fragment key={`d${i + 1}`}>
                            <AosAnimation animationType="fade-up" duration={3000} delay={350}>
                              <div className="card_col">
                                <div className="find-your-style-cardcover">
                                  <div className="card_top">
                                    <img src={Data.img.src} alt="card_top_img" />
                                  </div>
                                  <div className="card_bottom">
                                    <div className="card_bottom_cover">
                                      <h4>Plain And Check Shirts</h4>
                                      <p className="hike">
                                        <span className="inter">
                                          <img src={others.src} alt="hike" /> Interest
                                        </span>
                                        <span className="incris">
                                          <img src={aroww.src} alt="incris" /> 200%
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </AosAnimation>
                          </React.Fragment>
                        )
                      })}
                    </div>
                  </div>
                </div> */}
              </>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
